import { UnderConstructionPlaceholder } from 'components/UnderConstructionPlaceholder/UnderConstructionPlaceholder';
import styles from './Inventory.module.scss';

export function Inventory() {
    return (
        <div data-testid="Inventory" className={styles.container}>
            <UnderConstructionPlaceholder
                name="Inventory"
                explanation="This page will provide fuel inventory management functionality."
            />
        </div>
    );
}
